/* Chirag Banaras — scroll reveal + header-on-scroll.
   Progressive enhancement: if anything is unsupported the page
   still shows all content (reveal targets default to visible in
   the observer's fallback path). Skips work when the visitor
   prefers reduced motion. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    // Reveal each homepage/content section and key cards as they enter view.
    var scope = document.querySelector('main') || document.body;
    var candidates = scope.querySelectorAll(
      '.shopify-section > .section, .shopify-section > [class*="chirag-"], ' +
      '.chirag-relcard, .chirag-pcard, .chirag-cat, .chirag-jcard, ' +
      '.chirag-wed__tile, .chirag-budget-tile, .chirag-rev__item'
    );
    if (!candidates.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      // No animation: just make sure nothing is left hidden.
      candidates.forEach(function (el) { el.classList.add('chirag-inview'); });
      return;
    }

    candidates.forEach(function (el, i) {
      el.setAttribute('data-chirag-reveal', '');
      // small stagger for grouped cards
      var delay = Math.min((i % 6) * 60, 300);
      el.style.transitionDelay = delay + 'ms';
    });

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('chirag-inview');
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    candidates.forEach(function (el) { io.observe(el); });

    // Safety net: reveal everything after 3s in case an element
    // never triggers (e.g. off-screen in a horizontal rail).
    setTimeout(function () {
      candidates.forEach(function (el) { el.classList.add('chirag-inview'); });
    }, 3000);
  }

  function initHeaderShadow() {
    // Works whether the scroll happens on window (mobile) or .page-wrapper (desktop).
    var wrapper = document.querySelector('.page-wrapper');
    var root = document.documentElement;
    function onScroll() {
      var y = (wrapper && wrapper.scrollTop) || window.scrollY || 0;
      root.classList.toggle('chirag-scrolled', y > 20);
    }
    if (wrapper) wrapper.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function boot() {
    try { initReveal(); } catch (e) {}
    try { initHeaderShadow(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
